export const GET_RECIPES = 'GET_RECIPES';
export const SET_RECIPES = 'SET_RECIPES';
export const GET_RECIPES_ERROR = 'GET_RECIPES_ERROR';
export const APPEND_RECIPES = 'APPEND_RECIPES';
export const RESET_RECIPE_STATE = 'RESET_RECIPE_STATE';
export const CLEAR_RECIPES = 'CLEAR_RECIPES';
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';



// WEBPACK FOOTER //
// ./src/common/Components/RecipeSearch/state/types.js